import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgClass } from '@angular/common';
import {  CognitoCallback, Callback, CognitoUtil } from '../cognito/cognito.service';
import { UserRegistrationService } from '../cognito/user-registration.service';
import { NavbarService } from '../navbar/navbar.service';

import * as Materialize from 'angular2-materialize';

@Component({
  selector: 'app-registerconfirm',
  templateUrl: 'registerconfirm.component.html',
  styleUrls: ['registerconfirm.component.css'],
  providers: [UserRegistrationService, CognitoUtil]
})
export class RegisterconfirmComponent implements OnInit, OnDestroy, CognitoCallback {

  confirmationCode: string;
  email: string;
  errorMessage: string;
  private sub: any;

  accessToken: string;

  constructor(public configs: CognitoUtil,
              public regService: UserRegistrationService,
              public router: Router,
              public route: ActivatedRoute,
              public navService: NavbarService) { }

  ngOnInit() {
    this.navService.hide();
    console.log('Initializing registerconfirm');
    this.sub = this.route.params.subscribe(params => {
      this.email = params['email'];

    });

    console.log('Done. Email is:', this.email);

    this.errorMessage = null;
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  onLogin() {
    this.router.navigate(['/login']);
  }

  onRegister() {
    this.router.navigate(['/register']);
  }

  onConfirmRegistration() {
    if (this.email == null || this.confirmationCode == null) {
      this.errorMessage = 'All fields are required.';
      return;
    }

    this.errorMessage = null;

    console.log('About to call confirmRegistration.  Email:', this.email, ' Code:', this.confirmationCode);
    this.regService.confirmRegistration(this.email, this.confirmationCode, this);
  }

  cognitoCallback(message: string, result: any) {
    if (message != null) {
      // error
      this.errorMessage = message;
      console.log('message: ' + this.errorMessage);
    } else {
      // success
      // move to the next step
      console.log('Confirmed!');
      Materialize.toast('Successfully registered!  Please log in.', 5000);
      this.router.navigate(['/login']);
    }
  }
}

export class AccessTokenCallback implements Callback {
  constructor(public login: RegisterconfirmComponent) {

  }

  callback() {

  }

  callbackWithParam(result) {
    this.login.accessToken = result;
  }
}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/registerconfirm/registerconfirm.component.ts